<!--
  모든 페이지에 푸터를 붙인다.

  페이지들은 공통으로 `#app > .wrapper > #content > .area > .mobilearea` 껍데기를 각자
  템플릿에 그리고 있고, `.area` 는 height: 100dvh 로 고정돼 있다. 그래서 app.vue 에서
  <NuxtPage /> 뒤에 그냥 푸터를 두면 본문 길이와 상관없이 첫 화면 끝에 박혀 버린다.
  실제 콘텐츠 흐름 끝에 놓이려면 그 페이지의 .mobilearea 안쪽 맨 끝이어야 하므로,
  Teleport 로 현재 페이지의 .mobilearea 로 옮겨 붙인다.

  .mobilearea 가 없는 화면(채팅, 소셜 로그인 콜백 등)에서는 target 이 null 이라
  아무것도 그리지 않는다. EXCLUDED_PATHS 에 넣은 경로도 마찬가지로 건너뛴다.
-->
<template>
  <Teleport v-if="target && !excluded" :key="route.fullPath" :to="target">
    <Footer />
  </Teleport>
</template>

<script setup>
const route = useRoute();
const target = ref(null);

// 자기 자신과 하위 경로를 모두 제외한다. (예: /free, /free/freeInfo 둘 다 안 보임)
const EXCLUDED_PATHS = ["/free", "/ai-note", '/passLogin'];

// 하위 경로만 제외한다. 경로 자신에는 푸터가 그대로 보인다.
// (예: /content 는 보이고 /content/sidoList 는 안 보임)
const EXCLUDED_CHILD_PATHS = ["/content"];

const isExcluded = (path) =>
  EXCLUDED_PATHS.some((base) => path === base || path.startsWith(base + "/")) ||
  EXCLUDED_CHILD_PATHS.some((base) => path.startsWith(base + "/"));

const excluded = computed(() => isExcluded(route.path));

// 라우팅 직후엔 아직 새 페이지가 그려지기 전일 수 있다.
// nextTick 한 번으로 못 찾으면 다음 프레임에 한 번 더 본다.
const nextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));

// findTarget 은 중간에 await 를 하므로 여러 번이 겹쳐 돌 수 있다. 먼저 시작한(= 이전 경로의)
// 실행이 나중에 끝나면서 최신 결과를 덮어쓰지 않도록, 마지막 실행만 target 을 쓰게 한다.
let runId = 0;

const findTarget = async () => {
  const run = ++runId;

  target.value = null;
  if (excluded.value) return;

  await nextTick();
  let el = document.querySelector(".mobilearea");

  if (!el) {
    await nextFrame();
    el = document.querySelector(".mobilearea");
  }

  if (run !== runId) return;
  target.value = el;
};

onMounted(findTarget);
watch(() => route.fullPath, findTarget);
</script>
